class PublicTrainingPresenter {
  constructor(
    view,
    findObjectUseCase,
    saveObjectUseCase,
    updateObjectUseCase,
    saveFileUseCase
  ) {
    this.view = view;
    this.findObjectUseCase = findObjectUseCase;
    this.saveObjectUseCase = saveObjectUseCase;
    this.updateObjectUseCase = updateObjectUseCase;
    this.saveFileUseCase = saveFileUseCase;
    this.learn = null;
    this.object = null;
  }

  componentDidMount() {
    this.view.showProgress();
    Promise.resolve()
      .then(() => this.getTraining())
      .then(() => this.view.hideProgress())
      .catch((error) => {
        this.view.hideProgress();
        this.view.showError(error);
      });
  }

  getCurrentDateString() {
    const isoString = new Date().toISOString().slice(0, 11);
    const time = new Date().toTimeString().slice(0, 8);
    const milliseconds = ".000Z";
    return `${isoString}${time}${milliseconds}`;
  }

  getTraining() {
    this.learn = this.view.getTraining();
    this.view.setTraining(this.learn);
    if (!this.learn) {
      const id = this.view.getTrainingId();
      const query = {
        where: {
          id: id,
          date_exp: { $gte: this.getCurrentDateString() },
        },
        include: ["video.videos"],
      };
      return this.findObjectUseCase.execute("links", query).then(([data]) => {
        if (!data || !data.video.videos.length) {
          return this.view.showError("This link is expired.");
        }

        this.learn = data;
        console.log("store", this.learn);
        this.view.setTraining(this.learn);
      });
    }
  }

  onClickBack() {
    this.view.navigateBack();
  }
}

export default PublicTrainingPresenter;
